    import React, { useState, useEffect } from 'react';
    import axios from 'axios';
    import { Bar } from 'react-chartjs-2';
    import Snackbar from '@mui/material/Snackbar';
    import { useNavigate, Link } from 'react-router-dom';
import SnackbarContent from '@mui/material/SnackbarContent';
import api from '../../../../Services/api';
    import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    ArcElement
    } from 'chart.js';

    ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ArcElement);

    const AssessorEstablishmentMonthldata = () => {
        const [userType, setUserType] = useState('');
        const [companyId,setCompanyId] = useState("");
    const currentYear = new Date().getFullYear();
     const navigate = useNavigate();
      const [snackbarOpen, setSnackbarOpen] = useState(false);
      const [snackbarMessage, setSnackbarMessage] = useState('');
      const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
      const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');

      const [chartData, setChartData] = useState({
        labels: [],
        datasets: [
          {
            label: 'Accepted',
            data: [],
            backgroundColor: '#50c878',
            hoverBackgroundColor: '#45b36b',
            
            
          },
          {
            label: 'Rejected',
            data: [],
            backgroundColor: '#B22222',
            hoverBackgroundColor: '#a11d1d',
         
            
          },
          {
            label: 'UnderReview',
            data: [],
            backgroundColor: '#EFCC00',
            hoverBackgroundColor: '#dabb00',
            
            
          }
        ]
      });
      
 const [assessorFormData, setAssessorFormData] = useState({
        assessorCompanyName: '',
        assessorId: '',
        companyId:''
      });
        const [vendorsData, setVendorsData] = useState({});
        const [loading, setLoading] = useState(true);
      
    const [selectedQuarter, setSelectedQuarter] = useState('');
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [hoveredBar, setHoveredBar] = useState(null);
    const getStyledChartData = () => {
      return {
        labels: chartData.labels,
        datasets: chartData.datasets.map((dataset, dIndex) => ({
          ...dataset,
          backgroundColor: dataset.data.map((_, i) => {
            if (!hoveredBar) return dataset.backgroundColor;
    
            const isHovered = hoveredBar.datasetIndex === dIndex && hoveredBar.index === i;
            const baseColor = dataset.backgroundColor;
    
            // Convert to RGBA if not already
            const rgba = baseColor.replace('#', '').match(/.{1,2}/g)
              .map(hex => parseInt(hex, 16));
            const dimColor = `rgba(${rgba[0]},${rgba[1]},${rgba[2]},0.4)`;
    
            return isHovered ? baseColor : dimColor;
          }),
        }))
      };
    };
    
useEffect(() => {
      const sessionData = sessionStorage.getItem('user');
      const parsed = JSON.parse(sessionData);
      const id = parsed.id;
      const type = parsed.type;
    
      setUserType(type); // optional, only if you're using it elsewhere
    
      // First get assessor details
      if(type==='assessor'){
      api.assessor.findOne(id)
        .then(response => {
          const assessorInfo = response.data.data;
          const companyIdFromAssessor = assessorInfo.companyId;
          setAssessorFormData(assessorInfo);
          setCompanyId(companyIdFromAssessor); // set this first
          if(companyIdFromAssessor){
          fetchEstablishment(assessorInfo.companyId); 
          }
          else{
            setErrorSnackbarOpen(true)
            setSnackbarErrorMessage("Fetching data failed, please try again later")
          }// call with the correct companyId
    
        })
        .catch(error => {
          console.error('Error fetching company data:', error);
          setLoading(false);
        });
    } 
    }, [userType]); 
  


  const fetchEstablishment = async (companyId) => {
    try {
        const response = await api.client.getClient(companyId);
        if(response.status === 200){
        const data = response.data.data;
        console.log(data,"data.lnegth")
        setVendorsData(data);
        setLoading(false)
      

        }
        else if(response.status === 400){
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
            setVendorsData({})
        }
        else if(response.status === 404){
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
            setVendorsData({})
            setLoading(false)
        }
        else if(response.status === 500){
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message);
            setVendorsData({})
            setLoading(false)
        }
        else{
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage("Some error occured, please try again")
            setVendorsData({})
            setLoading(false)
        }
    } catch (error) {
        console.error("Vendor ID could not be fetched:", error);
    }
};
    useEffect(() => {
  if (companyId && selectedYear && selectedQuarter) {
    monthlyData(companyId, selectedYear, selectedQuarter);
  }
  else if(companyId && selectedYear){
    monthlyData(companyId, selectedYear);

  }
}, [companyId, selectedYear, selectedQuarter]);


    const monthlyData = async (companyId, year, quarter = '') => {
       const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const quarterMonths = quarter ? getQuarterMonths(quarter) : [...Array(12).keys()];
const monthLabels = quarterMonths.map(mIndex => months[mIndex]);
      
      try {
        const response = await axios.get(`https://www.grcpulse.in/api/EstMonthlyData/get-yearly/${companyId}`, {
            params: { year }
        });
       if(response.status === 200){
        const data = response.data.data;
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        console.log("mothlydata",data);
        const quarterMonths = quarter ? getQuarterMonths(quarter) : [...Array(12).keys()];

        const acceptedPercent = [];
        const rejectedPercent = [];
        const underReviewPercent = [];
        const monthLabels = [];
 
        quarterMonths.forEach((monthIndex) => {
            const monthData = data.find(item => item.month === (monthIndex + 1).toString().padStart(2, '0'));
            monthLabels.push(months[monthIndex]);
            if (monthData) {
            acceptedPercent.push(monthData.AcceptedPercent || 0);
            rejectedPercent.push(monthData.RejectedPercent || 0);
            underReviewPercent.push(monthData.UnderReviewPercent || 0);
            } else {
            acceptedPercent.push(0);
            rejectedPercent.push(0);
            underReviewPercent.push(0);
            }
        });

        setChartData({
            labels: monthLabels,
            datasets: [
            {
                label: 'Accepted',
                data: acceptedPercent,
                backgroundColor: '#50c878',
                 barThickness: 13,

            
                 
            },
            {
                label: 'Rejected',
                data: rejectedPercent,
                backgroundColor: '#B22222',
                 barThickness: 13,
            },
            {
                label: 'UnderReview',
                data: underReviewPercent,
                backgroundColor: '#EFCC00',
                 barThickness: 13,
            }
            ]
        });
        } 
    
    else if(response.status === 404)
        {
       setErrorSnackbarOpen(true);
       setSnackbarErrorMessage(response.data.message)
      setChartData({ labels: monthLabels, datasets: [] });
        }
        else if(response.status === 400){
            setErrorSnackbarOpen(true);
       setSnackbarErrorMessage(response.data.message)
       setChartData({ labels:monthLabels, datasets: [] });
        }
        else if(response.status === 500){
            setErrorSnackbarOpen(true);
       setSnackbarErrorMessage(response.data.message)
        setChartData({ labels: monthLabels, datasets: [] });
        }
        else{
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage('Some error occured, please try again later');
        }
    }catch (error) {
        console.error("Error fetching monthly data:", error);
        }
    };

    const getQuarterMonths = (quarter) => {
        switch (quarter) {
        case 'Q1':
            return [0, 1, 2];
        case 'Q2':
            return [3, 4, 5]; 
        case 'Q3':
            return [6, 7, 8]; 
        case 'Q4':
            return [9, 10, 11]; 
        default:
            return [];
        }
    };
    const handleBarClick = ({ status, month, year }) => {
      console.log("clicked")
      console.log(status,"month");
      navigate('/establishmentMonthlydata', {
        state: {
          filter: status.charAt(0).toLowerCase()+ status.slice(1),
          month: month < 10 ? `0${month}` : month,
          year: year,
          id: companyId
        },
      })
    };
    
    const handleQuarterChange = (e) => {
        setSelectedQuarter(e.target.value);
    };

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    return (
        <div className='m-0 p-0'>
            <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    severity="success"
                    open={snackbarOpen}
                    autoHideDuration={2000}
                    onClose={() => setSnackbarOpen(false)}
                    sx={{ marginTop: '2.9%', marginRight: '7%' }}
                  >
                    <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
                  </Snackbar>
                  <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    severity="error"
                    open={errorSnackbarOpen}
                    autoHideDuration={2000}
                    sx={{ marginTop: '2.9%', marginRight: '7%' }}
                    onClose={() => setErrorSnackbarOpen(false)}
                  >
                    <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
                  </Snackbar>
             <div style={{ backgroundColor: 'white', border: '1px solid lightgray' }}>
             
          <h6 className="text-light text-center p-2" style={{backgroundColor:'rgba(0,0,0,0.85)'}}>Establishment Monthly Data</h6>
       
        <div className=" d-grid">
         
          
            <div className="m-2 d-flex justify-content-end">
            
               

                <select  onChange={handleYearChange} value={selectedYear}  style={{border:'1px solid lightgray',borderRadius:'4px', cursor:'pointer'}}>
                {Array.from({ length: currentYear - 2020 + 1 }, (_, i) => 2020 + i).map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                </select>
                 <select  className="mx-2" onChange={handleQuarterChange} value={selectedQuarter}  style={{border:'1px solid lightgray',borderRadius:'4px', cursor:'pointer'}}>
                <option value="">All Months</option> 
                <option value="Q1">Q1</option>
                <option value="Q2">Q2</option>
                <option value="Q3">Q3</option>
                <option value="Q4">Q4</option>
                </select>
            </div>
          

            <div>
            <Bar
 data={getStyledChartData()}
  options={{
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const datasetIndex = elements[0].datasetIndex;
        const index = elements[0].index+1;

        const status = chartData.datasets[datasetIndex].label;
        const month = index;
        const year = selectedYear; // Assuming you have this from state or props

         handleBarClick({ status, month, year });
      }
    },
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    
      if (chartElement.length > 0) {
        const { datasetIndex, index } = chartElement[0];
        if (!hoveredBar || hoveredBar.datasetIndex !== datasetIndex || hoveredBar.index !== index) {
          setHoveredBar({ datasetIndex, index });
        }
      } else {
        setHoveredBar(null); // Clear on mouse out
      }
    },
    
    interaction: {
      mode: 'nearest',
      intersect: true,
    },
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem) {
            const percentageValue = tooltipItem.raw;
            const datasetLabel = tooltipItem.dataset.label; // Get the label of the dataset
            let status = '';

            // Determine the status based on the dataset label
            if (datasetLabel === 'Accepted') {
                status = 'Accepted';
            } else if (datasetLabel === 'Rejected') {
                status = 'Rejected';
            } else if (datasetLabel === 'UnderReview') {
                status = 'Under Review';
            }

            // Return the status with the percentage
            return  `${status}: ${percentageValue}%`;
          },
        },
      },
      datalabels: {
        display: false, // Enable the datalabels plugin
        color: 'black', // Set label color
        align: 'center', // Center the label horizontally
        anchor: 'end', // Position the label at the top of the bar
        font: {
          size: 10,
          weight:'bold'
          
        
        
        },
       
        
        formatter: function (value) {
          if (value != 0) {
            return `${value}%`; // Format as percentage
          } else {
            return '';
          }
        },
         
      },
     
    },
   
    scales: {
      x: {
        title: { display: true },
        ticks: { color: 'gray' },
        grid: { display: false },
      },
      y: {
        title: { display: true },
        min: 0,
        max: 100,
        stepSize: 20,
        ticks: { display: true, color: 'gray' ,callback: value => value + '%' },
        grid: { display: false },
      },
    },
  }}
/>


            </div>
        </div>
        </div>
        </div>
    );
    };

    export default AssessorEstablishmentMonthldata;
